import { Content, Portal } from '@radix-ui/react-popover';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './popover.scss';

type Props = ComponentPropsWithoutRef<typeof Content> & { portal?: boolean };
export const PopoverContent = ({
    className,
    align = 'center',
    sideOffset = 4,
    portal = true,
    ...props
}: Props) => {
    const content = (
        <Content
            data-testid="popover-content"
            align={align}
            sideOffset={sideOffset}
            className={cn('popover__content', className)}
            {...props}
        />
    );

    if (portal) {
        return <Portal>{content}</Portal>;
    }

    return content;
};
